import styled from 'styled-components';
import { TableWithFlatPagination } from 'dash-ui';

export const TransactionsTable = styled(TableWithFlatPagination)`
  border: 1px solid ${({ theme }) => theme.colors.n30};
  border-radius: ${({ theme }) => theme.space * 2}px;
  & > div {
    width: 100%;
  }
  table {
    table-layout: fixed;
  }
`;
